module.exports = __webpack_public_path__ + "img/商品营销.fdfd9e7a.png";